import type { SurveyOption } from '@citizen-walk/shared-types';

/**
 * アンケート選択肢の textarea (1 行に 1 つ) ⇔ `SurveyOption[]` の変換。
 * 回答は選択肢の文言で保存するので、行の文言がそのまま選択肢になる。
 * 空行は捨て、行頭・行末の空白は保存しない。重複は保存前に `findSurveyOptionProblem` で止める。
 */
export function surveyOptionsToText(options: SurveyOption[]): string {
  return options.map((o) => o.label).join('\n');
}

export function surveyOptionsFromText(text: string): SurveyOption[] {
  return text
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
    .map((label) => ({ label }));
}
